import { render, staticRenderFns } from "./goods-info-part.vue?vue&type=template&id=27c6930a"
import script from "./goods-info-part.vue?vue&type=script&lang=js"
export * from "./goods-info-part.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports